export const MESSAGE = {
	LABEL: 'Invitation Link Expired',
	DESCRIPTION: `	The invitation link you received to join Simplici Inc. has expired
						and is no longer valid. Please contact account owner for a new
						invitation link.`,
};

// SIM-87: a failed `?type=emailVerification` link is not a team invitation,
// and "contact account owner" sends a new sign-up to someone who cannot help.
export const EMAIL_VERIFICATION_MESSAGE = {
	LABEL: 'Verification Link Invalid',
	DESCRIPTION:
		'This email verification link is invalid or has expired. Request a new verification email from the sign-up screen and use the link in the latest email.',
	ACTION: 'Go to Sign In',
};
